import { AddEditForm } from '@/modules/workforce/Crew/components/AddEditForm';
import {
  AddCrewMemberResponse,
  IAddWorkerForm,
} from '@/modules/workforce/Crew/types';
// TODO: this is redundunt
export const AddEditWorker: React.FC<
  AddCrewMemberResponse & {
    workerId?: number;
    initialValues?: IAddWorkerForm;
    onSuccess?: () => void;
  }
> = ({ workerId, initialValues, supplierId, supplierName, onSuccess }) => {
  return (
    <AddEditForm
      supplierId={supplierId}
      subTitle={supplierName}
      crewType='worker'
      initialValues={initialValues}
      memberId={workerId}
      onSuccess={onSuccess}
    />
  );
};
